module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CA - Canada.19f7f1ab.svg";